// extracted by mini-css-extract-plugin
export default {"name":"G24ef87","address":"G5ac3ca"};